import { combineEpics } from 'redux-observable';
import { loadManagedIdentityNameListEpicReducer } from '../ducks/ManagedIdentityList.ducks';
export default combineEpics(loadManagedIdentityNameListEpicReducer.epic);

//# sourceMappingURL=ManagedIdentityList.js.map
